export default [
  {
    name: 'bank_reconciliation',
    path: '/bank_reconciliation',
    component: () =>
      import(
        /* webpackChunkName: "bank_reconciliation" */ './BankReconciliation.vue'
      )
  }
]
